import { RequestDetailEdit } from '../models/requestDetailEdit';
import { SaveResult } from '../../../../core/saveResult';

export interface IRequestDetailEditService {
    getDetail(trackingId: number, isRoleValidationRequired: boolean ): Promise<RequestDetailEdit>;
    save(requestDetailEdit: RequestDetailEdit): Promise<SaveResult>;
    deleteRequest(trackingIdToBeDeleted: number): Promise<SaveResult>;
    downloadSpreadSheet(trackingId : number): Promise<any>;
}

export class RequestDetailEditService implements IRequestDetailEditService {
    static $inject = ['$http'];

    constructor(private _$http: angular.IHttpService
        ) {
    }
    
    public getDetail(trackingId: number, isRoleValidationRequired : boolean): Promise<RequestDetailEdit> {
        return new Promise<any>((resolve, reject) => {
            this._$http.get(`/Request/detailEdit/${trackingId}?isRoleValidationRequired=${isRoleValidationRequired}`)
                .then((response: angular.IHttpPromiseCallbackArg<any>) => {
                   const detail = new RequestDetailEdit(response.data);
                   resolve(detail);
                });
        });
    }

    public save(requestDetail: RequestDetailEdit): Promise<SaveResult> {
        if (requestDetail.localizedCurrentTime == undefined)
            requestDetail.localizedCurrentTime = (new Date()).toLocaleString();
        
        return new Promise<SaveResult>((resolve, reject) => {
            this._$http.post<SaveResult>(`/Request/DetailUpdate`, requestDetail)
                .then(
                (response: angular.IHttpPromiseCallbackArg<SaveResult>) => {
                        const result = new SaveResult(response.data.errors, response.data.trackingId, response.data.rowVersion, "", "", "", "", "", "", 1, false);
                        resolve(result);
                    })
                .catch(
                (response: angular.IHttpPromiseCallbackArg<SaveResult>) => {
                        reject(response);
                    });
        });    

    }

    public deleteRequest(trackingId: number): Promise<SaveResult> {
        
        return new Promise<SaveResult>((resolve, reject) => {
            this._$http.delete(`/Request/DeleteShipment/${trackingId}`, { trackingId } as ng.IRequestShortcutConfig)
                .then((response: angular.IHttpPromiseCallbackArg<SaveResult>) => {
                    const saveResult = new SaveResult(response.data.errors, response.data.trackingId, response.data.rowVersion, "", "", "", "", "", "", 1, false);
                    resolve(saveResult);
                })
                .catch(
                (response: angular.IHttpPromiseCallbackArg<SaveResult>) => {
                        reject(response.data);
                    });
        });
    }


    public downloadSpreadSheet(trackingId: number): Promise<any> {

        return new Promise<any>((resolve, reject) => {
            this._$http.post(`/Request/GenerateExcel/${trackingId}`, trackingId,
                {
                    responseType: 'arraybuffer',
                    headers: { 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,  */*' }
                })
                .then(
                    (response: angular.IHttpPromiseCallbackArg<any>) => {
                        resolve(response.data);
                    })
                .catch(
                    (response: angular.IHttpPromiseCallbackArg<any>) => {
                        reject(response);
                        console.log(response)
                    });
        });
    }

}

angular.module('deliveryCreate.app').service('requestDetailEditService', RequestDetailEditService);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/services/requestDetailEditService.ts
 **/